//
//
//
//
//
//

export default {
  props: {
    iconName: {
      type: String,
      required: true
    }
  },
  computed: {
    svgIcon () {
      return `#icon-${this.iconName}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/iconSvg/svg.vue